export const projectsData = [
  {
    title: {
      ru: "KASCRM",
      en: "KASCRM",
    },
    description: {
      ru: `KASCRM — комплексная экосистема (CRM, ERP, BI), автоматизирующая бизнес-процессы компании.
      <br />Мой вклад и ключевые задачи:
      <br />Перевел проект с Inertia.js на Nuxt 3 (полноценное PWA с поддержкой Push).
      <br />Спроектировал и внедрил гибкую систему разрешений на основе ролей и отделов.
      <br />Интегрировал работу с WebSockets и API, участвовал в разработке внутреннего корпоративного чата и его внедрении в CRM.
      <br />Создал систему быстрых панелей, туров(гайдов) и автоматизировал создании видеогайдов по системе.
      <br />Настроил интеграции через n8n и Telegram-ботов для автоматизации внутренних процессов компании.`,
      en: `KASCRM is a comprehensive ecosystem (CRM, ERP, BI) that automates company business processes.
      <br />My contribution and key tasks:
      <br />Migrated the project from Inertia.js to Nuxt 3 (full PWA with Push support).
      <br />Designed and implemented a flexible role- and department-based permission system.
      <br />Integrated WebSockets and APIs, participated in the development of an internal corporate chat and its integration into the CRM.
      <br />Created a system of quick panels, tours (guides), and automated the creation of video guides for the system.
      <br />Configured integrations via n8n and Telegram bots to automate internal company processes.`,
    },
    image: new URL("../assets/atlon.png", import.meta.url).toString(),
    imageClass: "",
    links: [
      {
        text: "goToService",
        url: "https://kascrm.ru",
        className: "cta-btn--home",
      },
    ],
  },
  {
    title: {
      ru: "Сервис для приема смс",
      en: "SMS Reception Service",
    },
    description: {
      ru: `SMS-Service - представляет собой высоконагруженную платформу, обслуживающую тысячи пользователей ежедневно. Разработанный с использованием технологий Nuxt 2, Vue и Vuex.<br />
      Моя работа заключалась в локализации приложения с Nuxt-i18n, для пользователей из различных регионов. Кроме того, я занимался манипулированием данными, включая работу с датами при помощи библиотеки moment.js, а также выполнением других задач по оптимизации и логике функционирования сайта.`,
      en: `SMS-Service is a high-load platform serving thousands of users daily. Developed using Nuxt 2, Vue, and Vuex.<br />
      My work involved localizing the application with Nuxt-i18n for users from various regions. Additionally, I handled data manipulation, including working with dates using the moment.js library, as well as performing other optimization and site logic tasks.`,
    },
    image: new URL("../assets/sms-service.png", import.meta.url).toString(),
    imageClass: "",
    links: [
      {
        text: "goToService",
        url: "https://rent.sms-activation-service.com/",
        className: "cta-btn--home",
      },
    ],
  },
  {
    title: {
      ru: "Атлон ФМ",
      en: "Atlon FM",
    },
    description: {
      ru: `Руководство разработкой веб-проектов компании Атлон ФМ.
      <br />Мой вклад и ключевые задачи:
      <br />Участие в обсуждениях по развитию инфраструктуры.
      <br />Проектирование архитектуры проектов на Vue/KirbyCMS/Inertia.
      <br />Постановка технических задач, контроль сроки выполнения и объяснение бизнес процеессов.
      <br />Проведение Code Review и контроль качества кода младших специалистов.`,
      en: `Leading the development of web projects for Atlon FM company.
      <br />My contribution and key tasks:
      <br />Participation in discussions on infrastructure development.
      <br />Designing project architecture using Vue/KirbyCMS/Inertia.
      <br />Setting technical tasks, monitoring deadlines, and explaining business processes.
      <br />Conducting Code Review and quality control of junior specialists' code.`,
    },
    image: new URL("../assets/any-sites.png", import.meta.url).toString(),
    imageClass: "no-shadow",
    links: [
      { text: "site1", url: "https://deffecto.ru", className: "cta-btn--home" },
      { text: "site2", url: "https://spbatlon.ru", className: "cta-btn--home" },
      {
        text: "site3",
        url: "https://chistotop.ru",
        className: "cta-btn--home",
      },
    ],
  },
  {
    title: {
      ru: "Stockie CRM",
      en: "Stockie CRM",
    },
    description: {
      ru: `Stockie - представляет собой высоконагруженную crm платформу, объединяющую 100+ складов по всей России. Разработанный с использованием технологий Java, Vue, Vuex, Docker и т.д.<br />
      Моя роль заключалось в оптимизации кода и разработки логики функционирования сайта.`,
      en: `Stockie is a high-load CRM platform uniting 100+ warehouses across Russia. Developed using Java, Vue, Vuex, Docker, etc.<br />
      My role involved code optimization and developing the website's core logic.`,
    },
    image: new URL("../assets/stockie.jpg", import.meta.url).toString(),
    imageClass: "",
    links: [
      {
        text: "goToService",
        url: "https://stockie.ru",
        className: "cta-btn--home",
      },
    ],
  },
  {
    title: {
      ru: "Веб-сайт OpenCoin Project",
      en: "OpenCoin Project Website",
    },
    description: {
      ru: `Open Coin Project - с использованием современного фреймворка. Я участвовал в разработке этого сайта, внедряя функциональность и обеспечивая удобство использования для пользователей.<br />
      Мы стремились к легкому интерфейсу, который удовлетворял бы потребности целевой аудитории. Веб-сайт предоставляет информацию о самом проекте и его концепции, а также о других продуктах, предлагаемых разработчиками и дорожную карту проекта.`,
      en: `Open Coin Project - using a modern framework. I participated in the development of this site, implementing functionality and ensuring usability for users.<br />
      We aimed for a lightweight interface that would satisfy the target audience's needs. The website provides information about the project itself, its concept, other products offered by the developers, and the project roadmap.`,
    },
    image: new URL("../assets/open.png", import.meta.url).toString(),
    imageClass: "",
    links: [
      {
        text: "goToService",
        url: "https://openproject.app",
        className: "cta-btn--home",
      },
    ],
  },
  {
    title: {
      ru: "Сервис для туристов YAFT",
      en: "YAFT Service for Tourists",
    },
    description: {
      ru: `Мультиплатформенный сервис на Vue 3, Vuex с использованием PWА, который предлагает возможность планирования туристических походов по России.<br />
      Мы помогаем пользователям выбрать маршрут, подобрать необходимое снаряжение согласно погоде и типы туризма и предоставляем информацию о достопримечательностях и культурных событиях в выбранном регионе.
      <br />Этот мой pet-проект.`,
      en: `A multiplatform service using Vue 3, Vuex, and PWA that offers the ability to plan hiking trips across Russia.<br />
      We help users choose a route, select the necessary equipment according to the weather and type of tourism, and provide information about attractions and cultural events in the selected region.
      <br />This is my pet project.`,
    },
    image: new URL("../assets/yaft.png", import.meta.url).toString(),
    imageClass: "",
    links: [
      {
        text: "demo",
        url: "https://yaft.netlify.app/",
        className: "cta-btn--home",
      },
      {
        text: "github",
        url: "https://github.com/dazzv/yaft",
        className: "text-color-main",
      },
    ],
  },
  {
    title: {
      ru: "Carbon Hairstyle",
      en: "Carbon Hairstyle",
    },
    description: {
      ru: `"Carbon Hairstyle" - это инновационный сервис, объединяющий в себе функционал социальной сети с возможностями онлайн-платформы для ухода за волосами и создания стильных причесок. Разработанный на основе Nuxt 3 (с использованием SEO, SSR и Auth, i18n), а также TypeScript, Vue 3, Tailwind CSS и Vuex/Pinia.<br />
      Наш сервис включает в себя функционал публикаций, комментариев, личных кабинетов и т.д., обеспечивая возможность общения, обмена опыта и вдохновлением между пользователями. Этот мой второй pet-проект, в котором я вкладываю свою страсть .`,
      en: `"Carbon Hairstyle" is an innovative service combining social network functionality with online platform capabilities for hair care and styling. Developed with Nuxt 3 (featuring SEO, SSR, Auth, and i18n), TypeScript, Vue 3, Tailwind CSS, and Vuex/Pinia.<br />
      Our service includes publications, comments, personal accounts, etc., enabling communication, experience sharing, and inspiration among users. This is my second pet project, where I invest my passion.`,
    },
    image: new URL("../assets/carbon.jpg", import.meta.url).toString(),
    imageClass: "",
    links: [
      {
        text: "demo",
        url: "https://carbonh.netlify.app/",
        className: "cta-btn--home",
      },
      {
        text: "github",
        url: "https://github.com/dazzv/carbon",
        className: "text-color-main",
      },
    ],
  },
  {
    title: {
      ru: "Игра Монополия",
      en: "Monopoly Game",
    },
    description: {
      ru: `Проект "Монополия" на Vue 3 и Vuex - это веб-приложение, которое полностью воплощает классическую настольную игру с некоторыми улучшениями.
      <br />В приложении игроки могут бросать кубик для хода, покупать и продавать недвижимость, а также управлять своими финансами. Дизайн выполнен в современном стиле с простом интерфейсом.`,
      en: `The "Monopoly" project on Vue 3 and Vuex is a web application that fully recreates the classic board game with several enhancements.
      <br />In the app, players can roll dice to move, buy and sell real estate, and manage their finances. The design is modern with a simple interface.`,
    },
    image: new URL("../assets/monopoly.png", import.meta.url).toString(),
    imageClass: "",
    links: [
      {
        text: "demo",
        url: "https://dazzv-monopoly.netlify.app/",
        className: "cta-btn--home",
      },
      {
        text: "github",
        url: "https://github.com/dazzv/monopoly-game",
        className: "text-color-main",
      },
    ],
  },
];